const data={

    "aboutPage":[
                    "It is a Bangalore based Software Testing service Provider,Expert in Digital Marketing , Corporate Training & Staffing company which helps MNCs and middle level concerns in getting right Technology Training and candidates for contract/permanent positions.",
                    "We provide in house training/corporate training in the client site on all latest technologies-AI,Cyber Security,Dev Ops,Selenium,Dev Ops,Mobile Automation,Bigdata,Hadoop, Oracle,SQL,etc.",
                    "We focus on contract staffing & recruitment's in the categories-IT Software(Developers,Automations Testers ,scrum masters.Leads and Managers) & IT Enabled Services/BPO."
                ],

    "Product/Services":[
                            {
                                "cardHeading":"IT consulting-Testing & Development",
                                "cardContent":"We focuses first on the strategic needs of our clients’ businesses to determine the technology capabilities needed to support their long-term goals"
                            },
                            {
                                "cardHeading":"Digital Marketing",
                                "cardContent":"We provide digital marketing campaign by our industry experts to achieve your goal by helping to convert the leads to revenue."
                            },
                            {
                                "cardHeading":"Corporate Training",
                                "cardContent":"We provide in house training/corporate training in the client site on all latest technologies-AI,Cyber Security,Selenium,Dev Ops,Mobile Automation,Bigdata,Hadoop, Oracle,SQL,etc."
                            },
                            {
                                "cardHeading":"Contract Staffing/Placement",
                                "cardContent":"For those companies seeking to access talent and tweak their workforce as per their cyclical needs, We offer flexible, effective and short/long-term contract staffing solutions." 
                            }
                        ],

    "WhyWe":[ 
                "We assure you of our reliable service and look for always longtime work association by showing our expertise.",
                "We have industry expert guidance for the Testing services we offer and Also for Training assignments, We have the team of resources with real time experience.", 
                "Rich consultancy experience gives us good execution on the Staffing, Training and Technology processes in corporates, what works and  what does not."
            ],
    
    "addresses":[
                    {
                        "location":"Chennai",                                                              
                        "minorAddress":"2,6th Cross Road,",
                        "identify":"Sipcot,Siruseri,",
                        "cityAndPinCode":"Chennai-603 103"          
                    },{
                        "location":"Bangalore",
                        "minorAddress":"45, Nallurhalli Road,Whitefield,",
                        "identify":"Bangalore -560 066",
                        "cityAndPinCode":""
                    }   
                ]
        }

export default data